<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		created() {
			// document.querySelectorAll("link[rel*='icon']").forEach(item => {
			//     item.href = '/favicon1.ico';
			// })
		}
	}
</script>

<style lang="less">
	#app {
		color: #ffffff;
	}
</style>